import * as React from "react";
import styled, { css } from "styled-components";
import OtpInput from "react18-input-otp";

import { LoadingSpinner } from "src/library/components/LoadingSpinner";
import { ErrorNotice } from "src/core/shared/components/ErrorNotice";
import { Text } from "src/library/components/Text";
import { InputCss } from "src/library/components/Forms/Input";

interface ResetPasswordFormProps {
  errorMessage: string | null;
  loggingIn: boolean;
  onSubmit: (verificationCode: string) => void;
}

export const SmsMFAForm: React.FC<ResetPasswordFormProps> = ({
  loggingIn, onSubmit, errorMessage
}) => {
  const [ otp, setOtp ] = React.useState("");

  // auto submit if the user enters 6 digits and clear to avoid a loop
  React.useEffect(() => {
    if (otp.length === 6) {
      setOtp("");
      onSubmit(otp);
    }
  }, [ onSubmit, otp ]);

  return (
    <StyledMFAFormWrapper>
      {errorMessage ? (
        <ErrorNotice
          message={errorMessage}
          type="error"
        />
      ) : null}

      <Text
        as="h4"
        className="mfa-form-title"
      >
        Enter the code sent to your phone number
      </Text>

      <OtpInput
        className="mfa-inputs"
        onChange={setOtp}
        value={otp}
        autoComplete="one-time-code"
        numInputs={6}
        isInputNum
        isDisabled={loggingIn}
        hasErrored={!!errorMessage}
        inputStyle={{ width: "40px" }}
        separator={(
          <span>
            -
          </span>
        )}
      />
      ;

      {loggingIn && (
        <LoadingSpinner
          type="flat"
          position="inline"
        />
      )}
    </StyledMFAFormWrapper>
  );
};

const StyledMFAFormWrapper = styled.div`
  ${() => css`
    display: flex;
    flex-direction: column;
    align-items: center;

    .mfa-form-title {
      text-align: center;
    }

    input {
      width: 40px;
      ${InputCss}    
    }
  `}
`;
